export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "tableName": "WMEVALUATIONEXPRESSION",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            } ,
            {
                "name": "COMMENT",
                "tableName": "WMEVALUATIONEXPRESSION",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },{
        "groupId": 2,
        "label": "",
        "fields": [
             
            {
                "name": "EXPRESSIONCODE",
                "tableName": "WMEVALUATIONEXPRESSION",
                "label": "Expr Code",
                "type": "text",
                "required": true,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    },{
        "groupId": 3,
        "label": "",
        "fields": [
             
            {
                "name": "DESCRIPTION",
                "tableName": "WMEVALUATIONEXPRESSION",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    },{
        "groupId": 4,
        "label": "",
        "fields": [
            
            {
                "name": "STATUS",
                "tableName": "WMEVALUATIONEXPRESSION",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            } 
        ]
    }
];

